import React from 'react';
import { ShieldCheck } from 'lucide-react';

export default function WorkflowCompatibilityNotice({ message }) {
  if (!message) return null;

  return (
    <section
      className="advoq-card"
      style={{
        padding: '16px 18px',
        borderRadius: '22px',
        border: '1px solid var(--border-subtle)',
        background: 'linear-gradient(180deg, color-mix(in srgb, var(--bg-elevated) 92%, var(--accent-primary) 2%), var(--bg-surface))',
        display: 'grid',
        gap: '8px',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: 'var(--text-primary)' }}>
        <span
          style={{
            width: '34px',
            height: '34px',
            borderRadius: '12px',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'var(--bg-elevated)',
            color: 'var(--accent-primary)',
          }}
        >
          <ShieldCheck size={16} />
        </span>
        <div style={{ fontSize: '14px', fontWeight: 700 }}>Compatibility mode</div>
      </div>
      <div style={{ color: 'var(--text-secondary)', fontSize: '13px', lineHeight: 1.6 }}>
        {message}
      </div>
    </section>
  );
}
